import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import type { ReviewSummaryItem } from 'shared/src/api';
import { EvaluationText } from 'shared/src/constant/domain/review/EvaluationText';

export const useLogClickSampleReview = (item: ReviewSummaryItem) => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const isPhotoReview = item.images.length > 0;

  return useCallback(() => {
    if (isPhotoReview) {
      logGoodsAnalytics({
        name: 'CLICK_SAMPLE_IMAGE',
        analytics: {
          REVIEW_SNO: item.sno,
          EVALUATION: EvaluationText[item.eval as 0 | 1],
          IS_BEST: item.is_best_review,
          POSITION: 'UPPER_REVIEW_SAMPLE_IMAGE',
        },
      });
    } else {
      logGoodsAnalytics({
        name: 'CLICK_SAMPLE_REVIEW',
        channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
        analytics: {
          REVIEW_SNO: item.sno,
          IS_IMAGE: false,
          EVALUATION: EvaluationText[item.eval as 0 | 1],
          IS_BEST: item.is_best_review,
        },
      });
    }
  }, [isPhotoReview, item.sno, item.eval, item.is_best_review, logGoodsAnalytics]);
};
